<template>
	<sideNav :page-title="pageTitle"></sideNav>
	<div v-show="showFlag">
		<div class="ld-panel-title">
			<router-link to="/verify" class="back-btn"><span></span>企业认证</router-link>
		</div>
		<div class="ld-panel-main">
			<el-steps :active="2" finish-status="success" simple style="margin-bottom: 30px;">
			    <el-step title="上传证件照片" />
			    <el-step title="确认并完善信息" />
				<el-step title="客服转账验证" />
				<el-step title="实名认证完成" />
			</el-steps>
			<el-form :rules="rules" ref="ruleFormRef" :model="groupForm" :label-width="formLabelWidth">
				<el-form-item label="认证方式">
					企业认证<router-link to="/verify" class="auth-back">【重新选择认证方式】</router-link>
				</el-form-item>
				<el-form-item label="打款金额" prop="checkCode">
					<el-input v-model="groupForm.checkCode" autocomplete="off" />
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submitForm(ruleFormRef)">下一步</el-button>
				</el-form-item>
			</el-form>
			<div class="foot-warn" style="margin-top: 60px;">
				<h4 class="title">审核说明：</h4>
				<div class="content">
					<p>1、资料审核通过后,系统会向您的企业对公账户打款;</p>
					<p>2、在您收到款项后,须把款项的金额提交本站进行验证;</p>
					<p>3、验证只能提交3次.3次失败后需要重新提交资料审核;</p>
					<p>(在资料审核通过后,也会有蓝队客服致电给您,询问打款金额,信息核对后.客服帮你审核通过)</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
	import { ref,reactive,onMounted} from 'vue';
	import { useRouter } from 'vue-router';
	import { authInfo,backfillcode } from '@/api/auth';
	import sideNav from '../../components/sideNav.vue';
	import { ElMessage } from 'element-plus';
	
	const router = useRouter();
	const pageTitle = 'account';
	const showFlag = ref(false);
	const formLabelWidth = ref('200px');
	const ruleFormRef = ref(null);
	const groupForm = ref({checkCode:''});
	const rules = reactive({
		checkCode: [
			{ required: true, message: '请填写打款金额', trigger: 'blur' }
		]
	});
	
	const generData = () => {
		authInfo().then((res) => {
			if(res.code === 200){
				if (res.data.authStatus == '1' && res.data.authType == '2') {
					router.push({ path: '/verify/success' })
				}
				if (res.data.businessStatus == '2') {
					router.push({ path: '/verify/audit' })
				}else if(res.data.businessStatus == '3'){
					router.push({ path: '/verify/businessinfo' })
				}else{
					showFlag.value = true;
				}
			}
		})
	};
	const submitForm = () => {
	  if (!ruleFormRef.value) return;
	  ruleFormRef.value.validate((valid) => {
	    if (valid) {
			const param = groupForm.value;
			backfillcode(param).then((res) => {
				if(res.code === 200){
					ElMessage({
						offset:70,
						message: res.msg,
						type: 'success'
					})
					router.push({ path: '/verify/success' })
				}
			})
	    } else {
	      return false;
	    }
	  });
	};
	
	onMounted(() => {
		generData()
	})
	
</script>

<style lang="scss" scoped>
	.server{
		margin:2px 0;
		.el-input{width: 28.5% !important; margin-right: 1%;}
	}
</style>